import React from "react";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

// Importing app files
import Routes from "./routes";
import trackErrors from "./ErrorTracking";
import ErrorBoundary from "./ErrorBoundary";
import ProductUpdates from "./ProductUpdates";
import store, { persistor } from "../redux/store";
import MaintenancePage from "../components/Pages/Public/Maintenance";

trackErrors();

const App = () => {
  return import.meta.env.VITE_MAINTENANCE_MODE === "true" ? (
    <MaintenancePage />
  ) : (
    <Provider store={store}>
      <PersistGate loading={<p>Loading ...</p>} persistor={persistor}>
        <ErrorBoundary>
          <ProductUpdates>
            <Routes />
          </ProductUpdates>
        </ErrorBoundary>
      </PersistGate>
    </Provider>
  );
};

export default App;
